.viewport {
  position: fixed;
  inset-block-end: var(--space-4);
  inset-inline-end: var(--space-4);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  width: min(380px, calc(100vw - 32px));
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 12px 12px 16px;
  padding-inline: 16px 8px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-inline-start-width: 4px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  animation: in 0.2s var(--ease);
}
.success {
  border-inline-start-color: var(--color-success-solid);
}
.success .icon {
  color: var(--color-success);
}
.error {
  border-inline-start-color: var(--color-danger-solid);
}
.error .icon {
  color: var(--color-danger);
}
.info {
  border-inline-start-color: var(--color-info-solid);
}
.info .icon {
  color: var(--color-info);
}
.icon {
  padding-block-start: 2px;
  flex: none;
}
.text {
  flex: 1;
  min-width: 0;
  font-size: var(--text-sm);
}
.text p {
  color: var(--color-text-muted);
  margin-block-start: 2px;
}
@keyframes in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}
